import { PermissionAttributesEnum } from "@verbleif/lib/src/composables/Permissions/permissions.enum";
import { ContextVoter } from "./composables/ContextVoter";

/**
 * Developer access requests are platform-wide, so only the global `*_any` operations exist (mirrors the backend
 * DeveloperAccessRequestVoter). Requesting and reading one's own request happen on the developer portal.
 */
export class DeveloperAccessRequestVoter extends ContextVoter {
  public canReadAny = (): boolean => {
    return !!this.permissionService.getGlobalPermissionForUser({
      attribute: PermissionAttributesEnum.GlobalOperationDeveloperaccessrequestReadany,
    });
  };

  public canDecideAny = (): boolean => {
    return !!this.permissionService.getGlobalPermissionForUser({
      attribute: PermissionAttributesEnum.GlobalOperationDeveloperaccessrequestDecideany,
    });
  };
}
